import { Box } from "@mui/material";
import { useState } from 'react';
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";
import { getDACCount, getDeviceDACLogsData } from '../../../action/devicelogs';
import { connect } from 'react-redux';
import DeviceDACLogs from './DeviceDACLogs/DeviceDACLogs';
import DACCount from './DACCount/DACCount';
import AppTabs from "../../Common/Tabs/AppTabs";

const DAC_TABS = [
    { label: "DAC Statistics" },
    { label: "Find Statistics" }
];

const DACStatistics = ({
    wrapperClass,
    dacData,
    getDeviceDACLogsData = () => { },
    getDACCount = () => { }
}) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            <Box sx={{ width: "100%", minWidth: 0, pb: 3 }}>
                <AppTabs
                    value={activeTab}
                    onChange={(e, newValue) => setActiveTab(newValue)}
                    tabs={DAC_TABS}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    tabMinWidth="auto"
                    appearance="neutral"
                />
                <Box sx={{ mt: 2 }}>
                    {activeTab === 0 && (
                        <DACCount
                            getDACCount={getDACCount}
                            dacData={dacData}
                        />
                    )}
                    {activeTab === 1 && (
                        <DeviceDACLogs
                            showSearch={true}
                            showCount={true}
                            deviceDetails={{}}
                            dacData={dacData}
                            getDeviceDACLogsData={getDeviceDACLogsData}
                        />
                    )}
                </Box>
            </Box>
        </ResponsiveContentWrapper>
    );
};

const mapStateToProps = (state) => ({
    dacData: state.report?.deviceLogs,
});

const mapDispatchToProps = (dispatch) => ({
    getDACCount: (params, cb) => dispatch(getDACCount(params, cb)),
    getDeviceDACLogsData: (params, cb) => dispatch(getDeviceDACLogsData(params, cb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DACStatistics);
